import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {
  VatService,
  InvoiceService,
  CreditNoteService,
} from 'src/app/api/invoice/services';
import { numberPattern } from '../../../models/validation-rules';
import {
  BusinessType,
  CreditType,
  InvoiceDetailDto,
  InvoiceDto,
  LineItemResponse,
  VatDto,
} from 'src/app/api/invoice/models';
import { IListParams } from 'src/app/shared/models/user.model';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmCreditNoteComponent } from '../../confirm-credit-note/confirm-credit-note.component';
import { RouteService } from 'src/app/shared/services/routeService';
import { CONSTANTS } from 'src/app/shared/models/constants';

@Component({
  selector: 'app-partial-credit-note',
  templateUrl: './partial-credit-note.component.html',
  styleUrls: ['./partial-credit-note.component.scss'],
})
export class PartialCreditNoteComponent implements OnInit {
  invoiceForm: FormGroup;
  invoiceDetails: InvoiceDetailDto = {};
  invoiceId = '';
  createLoading = false;
  vatOptions: VatDto[] = [];
  defaultVatPercentage = 15;
  defaultVat: VatDto = {};
  module = '';
  partialCreditLoader = false;
  vatParams = { page: 0, size: 300, search: '' };
  businessType: BusinessType = BusinessType.Sales || '';
  constants = CONSTANTS;
  SALES_ORDER = BusinessType.SalesOrder;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private vatService: VatService,
    private toastr: ToastrService,
    private invoiceService: InvoiceService,
    private location: Location,
    private crediteNoteServie: CreditNoteService,
    private RouteService: RouteService,
    private router: Router,

    public dialog: MatDialog
  ) {
    this.invoiceForm = this.fb.group({
      lineItems: this.fb.array([]),
    });
  }
  ngOnit() {
    const businessType = this.RouteService.findRoute(this.module).businessType;

    this.businessType = businessType || BusinessType.Sales;
  }
  addlineItems() {
    const lineItems = this.fb.group({
      itemDescription: ['', [Validators.required]],
      quantity: ['', [Validators.required, Validators.pattern(numberPattern)]],
      unitPrice: ['', [Validators.required, Validators.pattern(numberPattern)]],
      vat: [this.defaultVat, [Validators.required]],
      showUsd: [false, [Validators.required]],
    });
    this.lineItems.push(lineItems);
  }
  getTotalTaxableAmount(): number {
    const totalExcludingVat =
      this.invoiceDetails?.quotation?.totalExcludingVat ?? 0;
    const totalOutOfScope =
      this.invoiceDetails?.quotation?.totalOutOfScope ?? 0;
    return totalExcludingVat - totalOutOfScope;
  }

  getACMSTotalTaxableAmount(): number {
    const totalExcludingVat =
      this.invoiceDetails?.serviceOrder?.totalExcludingVat ?? 0;
    const totalOutOfScope =
      this.invoiceDetails?.serviceOrder?.totalOutOfScope ?? 0;
    return totalExcludingVat - totalOutOfScope;
  }

  goBack() {
    this.location.back();
  }
  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.module = params['businessType'];

      this.invoiceId = params['referralInvoice'];
      if (this.invoiceId) {
        this.loadInvoiceDetails();
      }
      this.loadInvoiceDetails();
      this.addlineItems();
    });

    this.fetchVat(this.vatParams);
    this.getTotalTaxableAmount();
  }
  loadInvoiceDetails() {
    const params = { id: parseInt(this.invoiceId) };
    this.invoiceService.getInvoiceById(params).subscribe({
      next: response => {
        if (response?.data?.[0]) {
          this.invoiceDetails = response.data[0];
        }
      },
      error: error => {
        this.toastr.error(error?.error?.message);
      },
    });
  }
  fetchVat(params: IListParams) {
    this.vatService.getAllVat(params).subscribe({
      next: response => {
        if (response?.data) {
          this.vatOptions = response.data || [];

          const defaultVat = this.vatOptions?.find(
            (item: VatDto) => item?.percentage === this.defaultVatPercentage
          );
          this.defaultVat = defaultVat || {};

          const lineItem = this.lineItems?.at(0) as FormGroup;

          const existingVatValue = lineItem.get('vat')?.value;

          if (!existingVatValue || Object.keys(existingVatValue).length === 0) {
            lineItem.get('vat')?.patchValue(this.defaultVat);
          }
        }
      },
      error: error => {
        this.toastr.error(error?.error?.message);
      },
    });
  }

  onSubmit() {
    const dialogRef = this.dialog.open(ConfirmCreditNoteComponent, {
      disableClose: true,

      data: {
        message: 'Are you sure you want to create credit note ?',
      },
      width: '',
      height: '',
    });

    const items = this.invoiceForm.value.lineItems.map(
      (item: LineItemResponse) => ({
        ...item,
        vatId: item?.vat?.id,
        type: 'OTHER',
      })
    );

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.partialCreditLoader = true;
        const formData = {
          items: items,
          creditType: CreditType.Partial,
          serviceDate: result?.serviceDate,
          reason: result?.reason,
          showUsd: result?.showUsd,
        };
        this.crediteNoteServie
          .createInvoiceCreditNote({
            id: parseInt(this.invoiceId),
            body: formData,
          })
          .subscribe({
            next: response => {
              this.partialCreditLoader = false;
              this.onClickRow(response?.data?.[0] || {});

              this.toastr.success(response.message);
            },
            error: error => {
              this.partialCreditLoader = false;
              this.toastr.error(error?.error?.message);
            },
          });
      }
    });
  }
  onClickRow(row: InvoiceDto) {
    const detailRoute = this.RouteService.findRoute(this.module);

    this.router.navigate([detailRoute.detailRoute + row.id], {
      queryParams: {
        type: 'CREDIT',
        businessType: this.businessType,
        module: this.module,
      },
    });
  }

  removelegs(index: number) {
    this.lineItems.removeAt(index);
  }
  get lineItems() {
    return this.invoiceForm.get('lineItems') as FormArray;
  }
}
